import { GarageInfoDto } from "@1games-ru/region-shared/dist/types/garage/garage";
import { isEmpty } from "lodash";
import VehicleMpProvider from "@/core/data-provider/data-mp/vehicle/vehicle-mp-provider";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";

export async function fetchTransportWarehouseGetInfo(): Promise<GarageInfoDto | null> {
  const response = await VehicleMpProvider.getMyGarageInfo();

  if (response instanceof RpcMpProviderSuccessResponse) {
    if (!isEmpty(response.data)) return response.data;
  }

  return null;
}
